import {styleRule, UI, StyleSheet} from "../../../../stem-core/src/ui/UI";

import {AddFunds} from "../add-funds/AddFunds";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {IndexCollapsed} from "../index-collapsed/IndexCollapsed";
import {WidgetActiveRouteElement} from "../../ui/WidgetActiveRouteElement";
import {isFirefox, isSafari, isSmallScreen} from "../../../Utils";
import {WALLET_EXPANDED_WIDTH} from "../../WidgetConstants";
import {Dispatcher} from "../../../../stem-core/src/base/Dispatcher";
import {authService} from "../../../../client/connection/Services";
import {autoredraw} from "../../../../stem-core/src/decorators/AutoRedraw";
import {iFrameUserDataService} from "../../../services/IFrameUserDataService";
import {IndexHome} from "./sections/IndexHome";


class IndexExpandedStyle extends StyleSheet {
    @styleRule
    container = {
        position: "relative",
        overflow: "hidden",
        background: this.themeProps.WHITE,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        justifyContent: "flex-end",
    };

    @styleRule
    hidden = {
        opacity: 0,
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
    };

    @styleRule
    homePageContainer = {
        height: isSafari() ? "100%" : this.themeProps.FIT_CONTENT_IMPORTANT,
        minWidth: WALLET_EXPANDED_WIDTH,
        maxHeight: isFirefox() ? "initial !important" : "",
        paddingTop: "12px !important",
    };

    @styleRule
    home = {
        cursor: "initial",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        position: "relative",
        paddingBottom: 39,
        overflow: "hidden",
        borderRadius: isSmallScreen() ? 0 : "12px 12px 0 0",
    };

    @styleRule
    walletSection = {
        width: "100%",
        position: "absolute",
        zIndex: 3,
        minWidth: 360,
    };
}

// TODO Rethink how this works with donations.
@autoredraw(iFrameUserDataService)
@registerStyle(IndexExpandedStyle)
export class IndexExpanded extends WidgetActiveRouteElement {
    hiddenHomeSection = true;

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.home);
        // This is to fix the bad color transition when closing a modal
        if (!authService.isAuthenticated()) {
            attr.setStyle("opacity", 0);
        }
    }

    render() {
        const {styleSheet} = this;

        if (this.hiddenHomeSection || !authService.isAuthenticated()) {
            return [
                <div ref="container" className={styleSheet.container + (this.hiddenHomeSection ? styleSheet.hidden : "")}>
                    <IndexHome ref="nav" className={styleSheet.homePageContainer}/>
                </div>,
                <IndexCollapsed/>
            ];
        }

        return [
            <div ref="container" className={styleSheet.container + (this.hiddenHomeSection ? styleSheet.hidden : "")}>
                <IndexHome ref="nav" className={styleSheet.homePageContainer}/>
            </div>,
            <AddFunds ref="widgetAddFunds"
                      className={styleSheet.walletSection + (this.hiddenHomeSection ? styleSheet.hidden : "")} />,
            <IndexCollapsed/>,
        ];
    }

    static show(options) {
        Dispatcher.Global.dispatch("preventCardScrollDisplay");
        this.instance.hiddenHomeSection = false;
        this.instance.updateOptions(options);
    }

    static hide() {
        this.instance.hiddenHomeSection = true;
        this.instance.redraw();
    }

    computeHeight() {
        return this.nav.computeHeight();
    }
}
